import { Close, LinkOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { trackerUrls } from '@/tracker/config/urls';
import { QueueRef } from '@/tracker/types';
import { copyToClipboard } from '@/utils/copyToClipboard';

import s from './IssueCardHeader.module.scss';

type Props = {
  issueKey: string;
  /** null — задача не загрузилась: только ключ, без ссылки на очередь и копирования */
  queue: QueueRef | null;
  onClose: () => void;
};

/** Шапка карточки: «Очередь / KEY», копирование ссылки и закрытие */
const IssueCardHeader: React.FC<Props> = ({ issueKey, queue, onClose }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyLink = async () => {
    const url = `${window.location.origin}${trackerUrls.issue(issueKey)}`;

    setIsCopied(!(await copyToClipboard(url)).isError);
  };

  return (
    <header className={s.header}>
      <span className={s.header__breadcrumbs}>
        {queue ? (
          <>
            <Link to={trackerUrls.queue(queue.key)} className={s.header__link}>
              {queue.name}
            </Link>{' '}
            / <b>{issueKey}</b>
          </>
        ) : (
          issueKey
        )}
      </span>
      {queue && (
        <Tooltip title={isCopied ? 'Скопировано' : 'Скопировать ссылку'}>
          <IconButton
            aria-label="Скопировать ссылку на задачу"
            onMouseLeave={() => setIsCopied(false)}
            onClick={copyLink}
          >
            <LinkOutlined />
          </IconButton>
        </Tooltip>
      )}
      <IconButton aria-label="Закрыть карточку" onClick={onClose}>
        <Close />
      </IconButton>
    </header>
  );
};

export { IssueCardHeader };
